import { createDefaultDispatcher34z5li45gie67 as createDefaultDispatcher } from './CoroutineContext.mjs';
import { Unconfined_getInstance17f2s8ko18ri2 as Unconfined_getInstance } from './Unconfined.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { MainCoroutineDispatcher158x49bd8e9gp as MainCoroutineDispatcher } from './MainCoroutineDispatcher.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DispatchersClass;
function Dispatchers() {
  if (DispatchersClass === VOID) {
    class $ {
      constructor() {
        Dispatchers_instance = this;
        this.j13_1 = createDefaultDispatcher();
        this.k13_1 = Unconfined_getInstance();
        this.l13_1 = new (JsMainDispatcher())(this.j13_1, false);
        this.m13_1 = null;
      }
      n13() {
        var tmp0_elvis_lhs = this.m13_1;
        return tmp0_elvis_lhs == null ? this.l13_1 : tmp0_elvis_lhs;
      }
    }
    initMetadataForObject($, 'Dispatchers');
    DispatchersClass = $;
  }
  return DispatchersClass;
}
var Dispatchers_instance;
function Dispatchers_getInstance() {
  if (Dispatchers_instance === VOID)
    new (Dispatchers())();
  return Dispatchers_instance;
}
var JsMainDispatcherClass;
function JsMainDispatcher() {
  if (JsMainDispatcherClass === VOID) {
    class $ extends MainCoroutineDispatcher() {
      constructor(delegate, invokeImmediately) {
        super();
        this.i1m_1 = delegate;
        this.j1m_1 = invokeImmediately;
        this.k1m_1 = this.j1m_1 ? this : new (JsMainDispatcher())(this.i1m_1, true);
      }
      k17() {
        return this.k1m_1;
      }
      y12(context) {
        return !this.j1m_1;
      }
      b13(context, block) {
        return this.i1m_1.b13(context, block);
      }
      toString() {
        var tmp0_elvis_lhs = this.l17();
        return tmp0_elvis_lhs == null ? this.i1m_1.toString() : tmp0_elvis_lhs;
      }
    }
    initMetadataForClass($, 'JsMainDispatcher');
    JsMainDispatcherClass = $;
  }
  return JsMainDispatcherClass;
}
//region block: exports
export {
  Dispatchers_getInstance as Dispatchers_getInstancewbokwrm9sosb,
};
//endregion

//# sourceMappingURL=Dispatchers.mjs.map
